import { render } from "./cohort-settings-status.vue?vue&type=template&id=0c529d4e"
import script from "./cohort-settings-status.vue?vue&type=script&lang=js"
export * from "./cohort-settings-status.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/vc4a/vc4a/wp-content/themes/vc4africa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__